module.exports = __webpack_public_path__ + "static/media/30.e86afbe2.mp3";